import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Gallery = () => {
  const images = [
    'https://via.placeholder.com/300x200?text=Project+1',
    'https://via.placeholder.com/300x200?text=Project+2',
    'https://via.placeholder.com/300x200?text=Project+3',
    // Add more
  ];

  return (
    <Container className="my-5">
      <h1>Gallery</h1>
      <p>Explore our completed and ongoing projects in Hyderabad.</p>
      <Row>
        {images.map((src, index) => (
          <Col md={4} key={index} className="mb-4">
            <img src={src} alt={`Project ${index + 1}`} className="img-fluid gallery-img" />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Gallery;